// A module for handling carousel images.
import axios from 'axios'
import { CLOUDINARY_NAME, CLOUDINARY_PRESET_NAME } from '../../constants'

export const imageFileName = (imageNumber) => {
  return 'public/carousel/carousel_' + imageNumber + '.png'
}

export const CLOUDINARY_RESOURCES_URL = `https://res.cloudinary.com/${CLOUDINARY_NAME}`

/**
 * @todo swap with "head" request to save bandwidth
 */
export const getImagePath = (menuUuid, index, timestamp) =>
  fetch(`${CLOUDINARY_RESOURCES_URL}/image/upload/w_1080,h_1920/v${timestamp}/${getCloudinaryPublicId(menuUuid, index)}`).then(
    (response) => {
      if (response.status === 200) {
        return response.url
      } else {
        return null
      }
    },
  )

/**
 * Check if the images exist by sending HEAD requests.
 * @param {string[]} urls - The image URLs to check.
 * @returns {Promise<string[]>} - A promise that resolves to an array of existing image URLs.
 */
export const checkImagesExist = async (urls) => {
  const validated = []
  for (const url of urls) {
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()

    // manually cancel after 2000 ms
    const timeout = setTimeout(() => {
      source.cancel('Request timeout')
    }, 2000)

    try {
      // use lightweight head request to check if image exists
      const res = await axios.head(url, { headers: {}, cancelToken: source.token })
      clearTimeout(timeout)

      if (res.status === 200) {
        validated.push(url)
      }
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Error checking image exists:', err)
      }
      clearTimeout(timeout)
    }
  }

  return validated
}

export const getCloudinaryPublicId = (menuUuid, index) => `${CLOUDINARY_PRESET_NAME}/${menuUuid}_${index}`
